import React from 'react';
import { getIconBaseUrl } from '../../../utils/assets';
import { getRegions } from '../../../utils/parks/getters';
import SelectButton from './SelectButton';
import styles from './LocationSelect.module.scss';
export const LocationSelect = ({ regions = getRegions(), onChange = () => { }, value = null, dogSelected = false, }) => (<div className={styles.container}>
    <ul className={styles.list}>
      {regions === null || regions === void 0 ? void 0 : regions.map(({ name, parks }) => {
        if (!parks.length)
            return null;
        return (<li key={name} className={styles.item}>
              <p className={styles.title}>{name}</p>
              <ul className={styles.subList}>
                {parks.map(({ name, code, features, }) => (<li key={code} className={`${styles.subItem} ${!features.allowDogs ? 'wide' : ''} `}>
                      <SelectButton key={code} value={name} onClick={() => onChange(code)} checked={value === code} disabled={dogSelected && !features.allowDogs}/>
                      {!features.allowDogs && (<img className={styles.icon} alt='No dogs allowed' src={getIconBaseUrl('no-dogs-grey.svg')}/>)}
                    </li>))}
              </ul>
            </li>);
    }).filter((x) => x)}
    </ul>
  </div>);
export default LocationSelect;
